var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "push-animation position-relative" }, [
    _c("div", { staticClass: "push-animation-img" }, [
      _vm.pushAnimation.visual != null
        ? _c("div", [
            _c("img", {
              staticClass: "fill-img",
              attrs: {
                src: _vm.pushAnimation.visual.src,
                alt: _vm.pushAnimation.visual.alt,
              },
            }),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "push-animation-text-block" }, [
      _c(
        "div",
        {
          staticClass: "push-animation-text-tile p-2",
          class: _vm.pushAnimation.backgroundColor,
        },
        [
          _vm.pushAnimationTimerBanner.tag
            ? _c(
                "div",
                { staticClass: "mb-1" },
                [
                  _c("tag-timer-banner", {
                    attrs: {
                      banner: _vm.pushAnimationTimerBanner.tag,
                      "timer-end-date-in-milliseconds":
                        _vm.pushAnimationTimerBanner.timerEndDateInMilliseconds,
                      "count-down-color":
                        _vm.pushAnimationTimerBanner.timerCssClass,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.pushAnimation.title
            ? _c("div", {
                staticClass: "mb-0 h3",
                domProps: { innerHTML: _vm._s(_vm.pushAnimation.title) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pushAnimation.text
            ? _c("p", {
                domProps: { innerHTML: _vm._s(_vm.pushAnimation.text) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pushAnimation.additionalText
            ? _c("p", {
                staticClass: "mb-2",
                domProps: {
                  innerHTML: _vm._s(_vm.pushAnimation.additionalText),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pushAnimation.url
            ? _c(
                "a",
                {
                  class: [
                    "btn btn-secondary me-1 mb-1 mb-xl-0",
                    { "btn-inverse": _vm.isBackgroundDark },
                  ],
                  attrs: {
                    href: _vm.pushAnimation.url,
                    "data-oevent-category":
                      _vm.pushAnimation.buttonTms.category,
                    "data-oevent-action": _vm.pushAnimation.buttonTms.action,
                    "data-oevent-label": _vm.pushAnimation.buttonTms.label,
                  },
                },
                [_vm._v(_vm._s(_vm.pushAnimation.urlAccessWording))]
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }